import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { LocaleModel, useGetLocaleFormatsQuery } from '@casops/store/apis/settingsApi';
import { useMemo } from 'react';

export const useLocaleFormatOptions = (): DropdownItemProps<string>[] => {
  const { data: localeFormats } = useGetLocaleFormatsQuery();

  return useMemo<DropdownItemProps<string>[]>(() => {
    if (typeof localeFormats !== 'undefined') {
      return localeFormats.map(({ id, name }: LocaleModel) => ({
        key: id,
        value: id,
        stringValue: id,
        label: name,
      }));
    }
    return [];
  }, [localeFormats]);
};

export default useLocaleFormatOptions;
